import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Link } from 'react-router-dom';
import Loading from '../../ui/Loading';

const required = value => value ? undefined : 'Required';

const getErrorMessage = ({ message }) => {
  if (message === 'Pending')
    return (
      <span>
        Your account has not been verified. Please contact
        {' '}
        <a href="mailto:customercare@twomey.com">customercare@twomey.com</a>
        {' '}
        for assistance
      </span>
    );
  return 'Invalid Credentials';
};

const LoginForm = props => {
  const { handleSubmit, submitting, loginError, inProgress, cartError } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="email"
        type="text"
        component={FormField.Input}
        placeholder="Email Address"
        validate={[required]}
      />
      <Field
        name="password"
        type="password"
        component={FormField.Input}
        placeholder="Password"
        validate={[required]}
      />
      <div>
        <div className="form-row">
          <div className="col-md-6">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={submitting || inProgress}
                style={{ marginRight: '0.5rem' }}
              >
                Login
              </button>
              {(submitting || inProgress) && <Loading small />}
            </div>
          </div>
          <div className="col-md-6 text-center text-center">
            <Link to="/account/forgot-password" className="form-link forgot">
              Forgot Password
            </Link>
          </div>
          {(loginError || cartError) &&
            <div className="col-md-12">
              <br />
              {loginError &&
                <p style={{ color: '#dc3545' }}>
                  {getErrorMessage(loginError || {})}
                </p>}
              {cartError &&
                <p style={{ color: '#dc3545' }}>{cartError.message || ''}</p>}
            </div>}
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'login-form'
})(LoginForm);
